import type { CoupleFeedbackSentiment } from '@lib/enums/couple-feedback-sentiment.enum'
import type { VenueReviewLinkDto } from '@lib/dto/couple-feedback.dto'

/**
 * Where the public links sit once an answer has been sent.
 * Wonderful invites a public review. A problem keeps the buttons, without
 * telling them to post. Nothing is offered before they send.
 */
export type PublicReviewEmphasis = 'next' | 'quiet'

/** Null until they have sent. The links are not part of choosing. */
export function publicReviewEmphasis(sentiment: CoupleFeedbackSentiment | null): PublicReviewEmphasis | null {
  if (sentiment === 'wonderful') return 'next'
  if (sentiment === 'needs_attention') return 'quiet'
  return null
}

/** The venue's review places as buttons, in the venue's order. Same list either way they answer. */
export function reviewLinkButtons(links: readonly VenueReviewLinkDto[]): { url: string; label: string }[] {
  return links.map((link) => ({ url: link.url, label: `Review on ${link.name}` }))
}
